// import auth from './auth'
import cache from './cache'
// import download from './download'
import tab from './tab'
import modal from './modal'
import { resetForm, parseTime } from '@/utils/index'

export default function installPlugins(app) {
  // 认证对象
  //app.config.globalProperties.$auth = auth
  // 缓存对象
  app.config.globalProperties.$cache = cache
  // 下载文件
  //app.config.globalProperties.$download = download
  // 页签操作
  app.config.globalProperties.$tab = tab
  // 模态框对象
  app.config.globalProperties.$modal = modal
  // 格式时间
  app.config.globalProperties.parseTime = parseTime
  // 刷新表单
  app.config.globalProperties.resetForm = resetForm

}
